import React from 'react';

const LoadingState = ({ text = 'Yükleniyor...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12" data-testid="loading-state">
      <div className="loading-coffee mb-4">
        <div></div>
        <div></div>
      </div>
      <p className="text-gray-600">{text}</p>
    </div>
  );
};

export default LoadingState;